import { render, staticRenderFns } from "./RsaPazienteInfoComponent.vue?vue&type=template&id=62dc923b"
import script from "./RsaPazienteInfoComponent.vue?vue&type=script&lang=js"
export * from "./RsaPazienteInfoComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports